module.exports = __webpack_public_path__ + "img/img5-1.7ba91833.png";